import React from "react";
import { HeroProps } from "../types/appTypes";
import { useTranslation } from "react-i18next";

const HeroKitDigital: React.FC<HeroProps> = ({ title, text }) => {
  const { t } = useTranslation();

  return (
    <header className="swiss-section !border-t-0 pt-7 lg:pt-9">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">00 / Kit Digital</span>
        </div>
        <div className="col-span-12 lg:col-span-7">
          <h1 className="text-h1 font-bold tracking-tighter text-ink mb-5 max-w-[18ch]">
            {title}
          </h1>
          <p className="text-body-lg text-ink-70 max-w-prose">{text}</p>
        </div>
        <div className="col-span-12 lg:col-span-3 lg:col-start-10 border-t border-ink pt-4 flex flex-col gap-3">
          <span className="swiss-caption">{t("¡Comienza Ahora!")}</span>
          <span className="text-h4 font-medium tracking-tight text-ink">
            {t("Contáctanos")}
          </span>
          <a
            href="https://wa.me/34652598032"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary w-full"
          >
            WhatsApp
          </a>
          <a href="mailto:hola@kode.zone" className="btn btn-secondary w-full">
            {t("Email")}
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeroKitDigital;
